import { Alert, Box, Input, SpaceBetween } from "@cloudscape-design/components";
import Button from "@cloudscape-design/components/button";
import Modal from "@cloudscape-design/components/modal";
import { mdiAlert } from "@mdi/js";
import { Icon } from "@mdi/react";
import React, { useEffect, useState } from "react";

export interface ConfirmDeleteProps {
    header?: string;
    subtitle?: string;
    show: boolean;
    confirmWord: string;
    action: string;
    warning: string;
    onConfirm?: () => void;
    onDismiss?: () => void;
}

export const ConfirmDelete: React.FC<ConfirmDeleteProps> = ({
    header,
    show,
    subtitle,
    confirmWord = 'eliminar',
    action = 'Eliminar',
    warning = '',
    onConfirm,
    onDismiss,
}) => {
    const [confirmWord2, setConfirmWord2] = useState("");
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        setConfirmWord2("");
    }, [show]);
    return (
        <Modal visible={show} size="medium" header={<><Icon path={mdiAlert} size={1} color={"red"} /> {" "}{header}</>}
            onDismiss={() => {
                if (onDismiss) {
                    onDismiss();
                    show = false;
                }
            }}
            footer={<>

                <Box float="right">
                    <SpaceBetween direction="horizontal" size="xs">
                        <Button variant="link" onClick={() => {
                            if (onDismiss) {
                                show = false;
                                onDismiss();
                            }
                        }}>Cancelar</Button>
                        <Button variant="primary" disabled={confirmWord !== confirmWord2}
                            onClick={() => {
                                if (onConfirm && onDismiss) {
                                    show = false;
                                    onDismiss();
                                    onConfirm();
                                }
                            }
                            }>{action}</Button>
                    </SpaceBetween>
                </Box>
            </>
            }
        >

            <SpaceBetween size="m" direction="vertical">
                {subtitle !== "" && (
                    <div>
                        {subtitle}
                    </div>
                )}
                {warning !== "" && (
                    <Alert type="warning">
                        {warning}

                    </Alert>
                )}
                <div>
                    Para evitar acciones involuntarias, le solicitamos que proporcione un consentimiento adicional por escrito.
                </div>
                <div>
                    <strong>Para confirmar esta acción, escriba "{confirmWord}".</strong>
                </div>
                <SpaceBetween size="m" direction="horizontal">
                    <Input placeholder={confirmWord} value={confirmWord2} onChange={(event) => { setConfirmWord2(event.detail.value) }} />
                </SpaceBetween>
            </SpaceBetween>
        </Modal >
    );
};

export default ConfirmDelete;
